import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';

export const global_emits = new Vue();

import VueColumnsResizable from 'vue-columns-resizable';
import Multiselect from 'vue-multiselect';
import Notifications from 'vue-notification';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueUploadComponent from 'vue-upload-component';

import UserList from './components/users/list.vue';
import UserEdit from './components/users/edit.vue';
import UserLevels from './components/users/levels.vue';
import ItemList from './components/items/list.vue';
// import ItemEdit from './components/items/edit.vue';
import Scripts from './components/scripts/index.vue';
import ProductFeed from './components/products/feed.vue';

Vue.use(Notifications);
Vue.use(VueColumnsResizable);
Vue.use(VueRouter);
Vue.component('multiselect', Multiselect);
Vue.component('file-upload', VueUploadComponent);
Vue.prototype.$log = console.log;
Vue.config.productionTip = false;

const routes = [
	{path: '/', component: ItemList},
	{path: '/users', component: UserList},
	{path: '/users/levels', component: UserLevels},
	{path: '/users/edit/:id?', component: UserEdit},
	{path: '/items/edit/:ids?', component: ItemList},
	{path: '/items/:editor?', component: ItemList},
	{path: '/scripts', component: Scripts},
	{path: '/products/feed', component: ProductFeed }
];

Vue.directive('click-outside', {
	bind: function(el, binding, vnode) {
		el.clickOutsideEvent = function(event) {
			// here I check that click was outside the el and his childrens
			if (!(el == event.target || el.contains(event.target))) {
				// and if it did, call method provided in attribute value
				vnode.context[binding.expression](event);
			}
		};
		document.body.addEventListener('click', el.clickOutsideEvent);
	},
	unbind: function(el) {
		document.body.removeEventListener('click', el.clickOutsideEvent);
	},
});

const router = new VueRouter({
	routes
});

const scripts = [
	//{'label': 'Export', 'name': 'export'},
	//{'label': 'Import', 'name': 'import'},
	{'label': 'eBay', 'name': 'ebay'},
	{'label': 'eBay Categories', 'name': 'ebaycategories'},
	{'label': 'Website', 'name': 'website'},
	//{'label': 'Amazon', 'name': 'amazon'},
];

let user = {};

const fieldReadable = ( field, data ) => {
	if( data.user.level.read == "-1" || data.user.level.read.split(',').indexOf(field.toString()) > -1 )
		return true;

	return false;
};

const fieldWriteable = ( field, data ) => {
	if( data.user.level.write == "-1" || data.user.level.write.split(',').indexOf(field.toString()) > -1 )
		return true;

	return false;
};

const featureEnabled = ( feature, data ) => {
	if( data.user.level.extra.split(',').indexOf(feature) > -1 )
		return true;

	return false;
};

const sanitize = (str) => {
	if ((str===null) || (str===''))
		return '';
 	else
		str = str.toString();

	return str.replace(/[^\x20-\x7E]/g, '');
};



export default {
	scripts,
	user,
	fieldReadable,
	fieldWriteable,
	featureEnabled,
	sanitize,
	img_url: process.env.VUE_APP_IMAGES,
};


new Vue({
	router,
	render: (h) => h(App),
}).$mount('#app');
